import React, { useEffect, useState } from "react";
import "../results.css";

const ScoreGrid = ({ disabled }) => {
  const [teams, setTeams] = useState([]);
  const [dates, setDates] = useState([]);
  const [scores, setScores] = useState({});
  const [division, setDivision] = useState(0);
  const [showMessage, setShowMessage] = useState(false);

  // Fetch teams and dates from backend
  useEffect(() => {
    const fetchData = async () => {
      try {
        const teamsResponse = await fetch(
          `https://psc.squashforlife.com:9443/api/teams/${division}`
        );
        const datesResponse = await fetch(
          `https://psc.squashforlife.com:9443/api/dates/${division}`
        );
        const scoresResponse = await fetch(
          `https://psc.squashforlife.com:9443/api/populate_scores/${division}`
        );

        const teamsData = await teamsResponse.json();
        const datesData = await datesResponse.json();
        const scoresData = await scoresResponse.json();

        setTeams(teamsData);
        setDates(datesData);
        setScores(scoresData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [division]);

  // Handle score change
  const handleScoreChange = (teamName, date, value) => {
    setScores((prevScores) => ({
      ...prevScores,
      [teamName]: {
        ...prevScores[teamName],
        [date]: value,
      },
    }));
  };

  const handleSaveScores = async () => {
    console.log("Scores to be saved:", scores);

    try {
      const response = await fetch(
        `https://psc.squashforlife.com:9443/api/save_scores/${division}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ scores }),
        }
      );
      if (!response.ok) {
        throw new Error("Response not ok");
      }
      const result = await response.json();
      console.log("Scores saved successully: ", result);
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
      }, 3000);
    } catch (error) {
      console.error("Error saving scores:", error);
    }
  };

  // Calculates total scores for each team
  const calculateTotalScore = (teamName) => {
    const total = dates.reduce((sum, date) => {
      return sum + Number(scores[teamName][date]);
    }, 0);
    return total;
  };

  // Save team names and total scores to array and sort by highest score
  const teamScores = (teams || []).map((team) => ({
    name: team.name,
    score: calculateTotalScore(team.name),
  }));
  teamScores.sort((a, b) => b.score - a.score);

  return (
    <div>
      <h1 className="text-3xl font-bold mt-2 mb-4 flex flex-row justify-center items-center">
        Fall 2024 Doubles House League
      </h1>
      <p className="mx-2 mb-2">
        Please choose a houseleague division from the dropdown menu below to
        view the current season standings and weekly points breakdown.
      </p>
      <select
        className="mx-2 mb-5 mt-2 px-1 text-black bg-gray-200 rounded hover:bg-gray-300 border border-gray-400"
        name="division"
        id="division"
        value={division}
        onChange={(e) => setDivision(Number(e.target.value))}
      >
        <option value={0}>Select a division</option>
        <option value={1}>Division 1</option>
        <option value={2}>Division 2</option>
        <option value={3}>Division 3</option>
      </select>
      <hr></hr>
      {division !== 0 && (
        <div>
          <h1 className="mx-2 font-bold mt-5 mb-2">Team Standings by Points</h1>
          <div className="mx-2 mb-2">
            <table className="">
              <tbody>
                {teamScores.map((team, i) => (
                  <tr key={team.name}>
                    <td>{team.name}</td>
                    <td className="px-9">{team.score}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <h1 className="mx-3 font-bold mt-5 mb-2">Weekly Points Breakdown</h1>
          <div className="text-center mx-2">
            <table className="min-w-full border-collapse">
              <thead>
                <tr>
                  <th className="sticky top-0 left-0 z-20 bg-gray-200 border border-gray-400 w-auto">
                    Team
                  </th>
                  {(dates || []).map((date) => (
                    <th
                      className="sticky top-0 z-10 bg-gray-200 border border-gray-400 w-auto"
                      key={date}
                    >
                      {date}
                    </th>
                  ))}
                  <th className="sticky top-0 z-10 bg-gray-200 border border-gray-400 w-auto px-2">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {(teams || []).map((team) => (
                  <tr key={team.name}>
                    <td className="sticky left-0 z-10 bg-gray-200 border border-gray-400 w-auto px-3">
                      <div>{team.name}</div>
                    </td>
                    {dates.map((date) => (
                      <td
                        className="border border-gray-400 w-auto bg-white"
                        key={date}
                      >
                        <input
                          disabled={disabled}
                          type={disabled ? "text" : "number"}
                          min="0"
                          max="3"
                          value={scores[team.name][date]}
                          required
                          className="bg-white text-black text-center w-full opacity-100"
                          onChange={(e) => {
                            if (
                              Number(e.target.value) >= 0 &&
                              Number(e.target.value) <= 3 &&
                              e.target.value.length <= 1
                            ) {
                              handleScoreChange(
                                team.name,
                                date,
                                e.target.value
                              );
                            }
                          }}
                        />
                      </td>
                    ))}
                    <td className="sticky left-0 bg-gray-200 border border-gray-400 -z-10">
                      {calculateTotalScore(team.name)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button
            className="mt-2 mx-2 px-2 py-1 text-black bg-gray-200 rounded hover:bg-gray-300 border border-gray-400"
            hidden={disabled}
            onClick={handleSaveScores}
          >
            Save Scores
          </button>
        </div>
      )}

      {showMessage && (
        <div className="mx-2 text-green-600 animate-fadeOut">Scores saved!</div>
      )}
    </div>
  );
};

export default ScoreGrid;
